import axios from 'axios';

export default async function addCompanyGroups({
  accessToken,
  userId,
  company_group_ids,
  setTokenLikeExpired,
}) {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_AUTH_API_URL}/add/company-groups/${userId}`,
      { company_group_ids },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return err;
  }
}
